module.exports = __webpack_public_path__ + "static/media/plus.96ff30a8.svg";